import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

import NavBar from '@/components/nav/NavBar.vue';
import CreateContact from '@/components/dialogs/CreateContact.vue';
import EditContact from '@/components/dialogs/EditContact.vue';
import ImportContacts from '@/components/dialogs/ImportContacts.vue';
import DeleteContact from '@/components/dialogs/DeleteContact.vue';
// composables
import { computed, provide, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useDisplay } from 'vuetify';
import { useCreateContact, useEditContact, useImportContacts, useDeleteContact } from '@/hooks/useModals';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// components
const store = useStore();
const router = useRouter();
const { t, locale } = useI18n();

// onCreate: попытка авторизоваться, если в localStorage хранится токен и он еще не протух
store.dispatch('tryLogin');

// Модалки
const { createFormVisible, showCreateContact, closeCreateContact } = useCreateContact();
const { editFormVisible, editedContactId, showEditContact, closeEditContact } = useEditContact();
const { importFormVisible, showImportContacts, closeImportContacts } = useImportContacts();
const { deleteFormVisible, deletedContactId, showDeleteContact, closeDeleteContact } = useDeleteContact();
// прокидывем методы открытия модалок, чтобы сделать доступными из всех компонентов
provide('showCreateContact', showCreateContact);
provide('showEditContact', showEditContact);
provide('showImportContacts', showImportContacts);
provide('showDeleteContact', showDeleteContact);

// при протухании токена автоматически делать логаут
const didAutoLogout = computed(() => store.getters.didAutoLogout);
watch(didAutoLogout, (newValue, oldValue) => {
    if (newValue && newValue !== oldValue) {
        router.replace('/auth');
        store.dispatch('snackbar/showSnackbar', {
            message: t('auth.info.autoLogoutMessage'),
            type: 'success'
        });
    }
});

// при изменении языка сохранение выбора в localStorage
watch(locale, newValue => {
    localStorage.setItem('locale', newValue);
    store.dispatch('snackbar/showSnackbar', {
        message: t('i18n.message'),
        type: 'success'
    });
});

const isTouch = computed(() => useDisplay().platform.value.touch);
provide('isTouch', isTouch.value);

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ResultMessage = _resolveComponent("ResultMessage")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, { id: "inspire" }, {
    default: _withCtx(() => [
      _createVNode(NavBar),
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "route",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }),
      (_unref(createFormVisible) && !_unref(didAutoLogout))
        ? (_openBlock(), _createBlock(CreateContact, {
            key: 0,
            dialog: _unref(createFormVisible),
            onClose: _unref(closeCreateContact)
          }, null, 8, ["dialog", "onClose"]))
        : _createCommentVNode("", true),
      (_unref(editFormVisible) && !_unref(didAutoLogout))
        ? (_openBlock(), _createBlock(EditContact, {
            key: 1,
            dialog: _unref(editFormVisible),
            onClose: _unref(closeEditContact),
            id: _unref(editedContactId)
          }, null, 8, ["dialog", "onClose", "id"]))
        : _createCommentVNode("", true),
      (_unref(importFormVisible) && !_unref(didAutoLogout))
        ? (_openBlock(), _createBlock(ImportContacts, {
            key: 2,
            dialog: _unref(importFormVisible),
            onClose: _unref(closeImportContacts)
          }, null, 8, ["dialog", "onClose"]))
        : _createCommentVNode("", true),
      (_unref(deleteFormVisible) && !_unref(didAutoLogout))
        ? (_openBlock(), _createBlock(DeleteContact, {
            key: 3,
            dialog: _unref(deleteFormVisible),
            onClose: _unref(closeDeleteContact),
            id: _unref(deletedContactId)
          }, null, 8, ["dialog", "onClose", "id"]))
        : _createCommentVNode("", true),
      _createVNode(_component_ResultMessage)
    ]),
    _: 1
  }))
}
}

})